import { EHeatMapCategory } from '../../../../types-library/src'
import { State } from './types'

export const initialState: State = {
  isEnabledHeatMap: false,
  polygonTiles: [],
  isHoveredHeatMapCategorySelector: false,
  heatMapCategory: EHeatMapCategory.PRICE,
  polygonNavigation: {
    state: undefined,
    municipality: undefined,
    neighborhood: undefined,
    block: undefined,
    property: undefined,
  },
}
